import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import apiService from '../../services/api.service'
import { messageActions } from '../../store/message/index'
import storage from '../../services/stoage.service'
import utils from '../../utils'

const BASE_PATH = '/lottustech/notasfiscaisservico'
const crud = build(validate, BASE_PATH)
const prefix = 'crudNfse'

const newTypes = {
  SET_BOOLEAN_FILTER: `${prefix}setBooleanFilter`,
  RESET: `${prefix}reset`,
}

const actions = new Action(prefix, crud)
const types = Object.assign({}, actions.types, newTypes)

actions.setBooleanFilter = (field, value) => {
  return {
    type: types.SET_BOOLEAN_FILTER,
    field,
    value,
  }
}

actions.reset = () => {
  return {
    type: types.RESET,
  }
}

actions.downloadDanfSe = (oidNFSe) => {
  return (dispatch, getState) => {
    if (!oidNFSe) {
      // Sempre uma promise: quem chama encadeia o fim do loading no finally.
      return Promise.resolve()
    }
    // O emissor pode levar mais de um minuto para montar o PDF. Sem este aviso a tela fica
    // parada e parece travada. Fica fixo (sticky) porque some antes do fim da espera se
    // expirar sozinho — quem o remove e o desfecho, abaixo.
    dispatch(messageActions.messageShowMessages(makeMessages([getLabelNfse('nfse.label.solicitandoDanfe')], 'warn')))
    return apiService
      .get(`${BASE_PATH}/downloadDanfSe/${oidNFSe}`)
      .then((response) => {
        downloadDanfSeResponse(response.data, 'DanfSe - ' + oidNFSe + '.pdf')
        dispatch(messageActions.messageClearMessages())
        dispatch(
          messageActions.messageShowMessages(makeMessages([getLabelNfse('nfse.label.danfeConcluida')], 'success'))
        )
      })
      .catch((err) => {
        dispatch(messageActions.messageClearMessages())
        if (err.response) {
          const messages = err.response.data
          dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
        }
      })
  }
}

actions.downloadDanfSePorLancamento = (oidLancamento) => {
  return (dispatch, getState) => {
    if (oidLancamento) {
      dispatch(messageActions.messageShowMessages(makeMessages(['Solicitando nota fiscal!'], 'warn')))
      return apiService
        .get(`${BASE_PATH}/downloadDanfSePorLancamento/${oidLancamento}`)
        .then((response) => {
          const arrayBase64Notas = response.data
          let cont = 1
          arrayBase64Notas.forEach((danfse) => {
            downloadDanfSeResponse(danfse, 'DanfSe - ' + oidLancamento + cont + '.pdf')
            cont++
          })
          // O aviso de espera e sticky; quem o remove e o desfecho.
          dispatch(messageActions.messageClearMessages())
          dispatch(messageActions.messageShowMessages(makeMessages(['Sucesso no download da nota fiscal!'], 'success')))
        })
        .catch((err) => {
          dispatch(messageActions.messageClearMessages())
          if (err.response) {
            const messages = err.response.data
            dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
          }
        })
    }
  }
}
actions.reenviarNFS = (oidNFSe) => {
  return (dispatch, getState) => {
    if (oidNFSe) {
      return apiService.post(`${BASE_PATH}/reenviarnfs/${oidNFSe}`).then((response) => {
        // AO REENVIAR, REALIZAR ALGUMA OPERAÇÃO?
        dispatch(messageActions.messageShowMessages(makeMessages(['Nota reenviada com sucesso!'], 'success')))
      })
    }
  }
}

actions.cancelarNFS = (oidNFSe) => {
  return (dispatch, getState) => {
    if (oidNFSe) {
      return apiService
        .post(`${BASE_PATH}/cancelarNFS/${oidNFSe}`)
        .then((response) => {
          dispatch(messageActions.messageShowMessages(makeMessages(['Nota cancelada com sucesso!'], 'success')))
          dispatch(actions.loadById(oidNFSe))
        })
        .catch((err) => {
          if (err.response) {
            const messages = err.response.data
            dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
          }
        })
    }
  }
}

actions.enviarDanfeEmail = (oidNFSe) => {
  return (dispatch, getState) => {
    if (oidNFSe) {
      return apiService
        .post(`${BASE_PATH}/${oidNFSe}/enviar-email`)
        .then((response) => {
          const destinatario = response.data
          const mensagem = destinatario
            ? `Envio da nota por email agendado para ${destinatario}`
            : 'Envio da nota por email agendado'
          dispatch(messageActions.messageShowMessages(makeMessages([mensagem], 'success')))
        })
        .catch((err) => {
          if (err.response) {
            const messages = err.response.data
            dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
          }
        })
    }
  }
}

actions.sincronizarNFS = (oidNFSe) => {
  return (dispatch, getState) => {
    if (oidNFSe) {
      return apiService
        .put(`${BASE_PATH}/removerStatus/${oidNFSe}`)
        .then((response) => {
          dispatch(messageActions.messageShowMessages(makeMessages(['Operação finalizada'], 'success')))
          dispatch(actions.loadById(oidNFSe))
        })
        .catch((err) => {
          if (err.response) {
            const messages = err.response.data
            dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
          }
        })
    }
  }
}

// Textos vem do dicionario (tela 'nfse'); o fallback cobre base sem a migration aplicada, para
// a tela nunca mostrar aviso em branco.
const LABELS_PADRAO_NFSE = {
  'nfse.label.solicitandoDanfe':
    'Solicitação enviada. A geração da nota pelo emissor pode levar algum tempo — aguarde sem fechar a tela.',
  'nfse.label.danfeConcluida': 'Download da nota concluído.',
}

const getLabelNfse = (codigo) => {
  return utils.getMessage(storage.getAppLabels('nfse'), codigo) || LABELS_PADRAO_NFSE[codigo]
}

const makeMessages = (messages, type) => {
  let sticky = false
  let summary = 'Sucesso! '
  if (type === 'error') {
    summary = 'Erro!'
    sticky = true
  } else if (type === 'warn') {
    summary = 'Atenção!'
    // Espera longa: o aviso tem que continuar na tela ate o download terminar.
    sticky = true
  }
  return messages.map((message) => {
    return { sticky: sticky, summary: summary, severity: type, detail: message }
  })
}

function base64ToArrayBuffer(base64) {
  const binaryString = window.atob(base64)
  const bytes = new Uint8Array(binaryString.length)
  return bytes.map((byte, i) => binaryString.charCodeAt(i))
}

function downloadDanfSeResponse(danfse, filename) {
  if (isReportUrl(danfse)) {
    window.open(danfse, '_blank')
    return
  }
  const arrayBuffer = base64ToArrayBuffer(danfse)
  createAndDownloadBlobFile(arrayBuffer, filename)
}

function isReportUrl(value) {
  return typeof value === 'string' && /^(https?:\/\/|\/)/i.test(value)
}

function createAndDownloadBlobFile(body, filename) {
  const blob = new Blob([body])
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename)
  } else {
    const link = document.createElement('a')
    // Browsers that support HTML5 download attribute
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', filename)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

export { types, actions }
